import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentClient as defaultExperimentClient } from '$lib/services/experiments/client_v2';
import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';

/**
 * Builds the home page's conditions, which are evaluated in order.
 * @param {object} [services] - The services the conditions read.
 * @param {Pick<typeof defaultExperimentClient, 'getAssignment'>} [services.experimentClient] - Assigns the visitor to experiment arms.
 * @returns {{[key: string]: import('$lib/utils/page').PageCondition}} The conditions by name.
 */
function createPageConditions({ experimentClient = defaultExperimentClient } = {}) {
	return {
		// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
		inApp: {
			condition: async (config) => {
				return config.meta.inApp;
			},
			resolve: async () => {
				await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
				return await import('../_in-app/Page.svelte');
			},
		},
		// EXPERIMENT_CLEANUP: abcm2-nmhp-redesign
		browserParentValueProp: {
			condition: async (config) => {
				// functional requirement: only show the browser parent value prop to US English users
				const isUsEnglish =
					config.meta.viewerCountry === 'US' && config.meta.localeCode === 'en-US';
				if (!isUsEnglish) return false;

				const experiment = ACTIVE_EXPERIMENTS.ABCM2_NMHP_REDESIGN;
				const variant = await experimentClient.getAssignment({ autoMarkSeen: true, experiment });
				return variant === experiment.variants.test;
			},
			resolve: async () => {
				return await import('../_browser-parent-value/Page.svelte');
			},
		},
		default: {
			condition: async () => true,
			resolve: async () => {
				return await import('../_browser-2-0-rebrand/Page.svelte');
			},
		},
	};
}

const pageConditions = createPageConditions();

export { createPageConditions, pageConditions };
